import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/app/[locale]/bestelzuil/KioskPage.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExpertiseStatsSection"] */ "/tmp/8dea56281a098ba/components/sections/ExpertiseStatsSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/components/sections/FeaturesCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/components/sections/KeyTakeawaysSection.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/components/sections/KioskCaseStudy.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/components/sections/KioskFeatures.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/components/sections/KioskLocations.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KioskShowcase"] */ "/tmp/8dea56281a098ba/components/sections/KioskShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SolutionComparison"] */ "/tmp/8dea56281a098ba/components/sections/SolutionComparison.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/components/sections/SolutionsGrid.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/components/sections/SourcesSection.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["TrustBadges"] */ "/tmp/8dea56281a098ba/components/sections/TrustBadges.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VenuesSlider"] */ "/tmp/8dea56281a098ba/components/sections/VenuesSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BenefitCard"] */ "/tmp/8dea56281a098ba/components/ui/BenefitCard.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/components/ui/Container.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8dea56281a098ba/components/ui/LazyVideo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PricingFactorCard"] */ "/tmp/8dea56281a098ba/components/ui/PricingFactorCard.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/components/sections/TechPartnersSection.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
